module.exports = __webpack_public_path__ + "assets/events_war_plain.2b0d587c.svg";